import React, { FC, useMemo } from 'react';
import { DocumentTitle } from 'components/organisms/templates/projects/commons';
import { ProjectTemplateSpaceTabData } from 'data/templates/projects';
import { TextWrapper } from './styles';

export const RenderTaskName: FC<{
  onClick(): void;
  spaceTabName: string;
  spaceTab: ProjectTemplateSpaceTabData;
}> = ({ onClick, spaceTabName, spaceTab }) => {
  const iconSrc = useMemo(() => {
    if (Array.isArray(spaceTab.data.metaData?.links?.icon)) {
      return spaceTab.data.metaData?.links?.icon[0]?.href;
    }

    return undefined;
  }, [spaceTab]);

  return (
    <TextWrapper onClick={onClick}>
      <DocumentTitle title={spaceTabName} iconSrc={iconSrc} />
    </TextWrapper>
  );
};
